import { FailedToGetData, H2, Loading } from 'src/components/_commons';
import { houseToHouseServices } from 'src/services';
import { HTHSearcher } from './subcomponents/HTHSearcher';
import { HTHSection } from './subcomponents/HTHSection';
import { HTHShare } from './subcomponents/HTHShare';
import { setAlertResponse } from 'src/store';
import { sse } from '@/app-config';
import { sseEvents } from '@monorepo/helpers';
import { typeHTHTerritory, typeHTHFace, typeTerritoryNumber } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useGetCurrentUser } from 'src/custom-hooks';
import { useParams } from 'react-router';
import { useState, useEffect } from 'react';

export const HouseToHousePage = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const queryParams = Object.fromEntries(urlSearchParams.entries());
    //
    const blockQs = queryParams.b;
    const faceQs = queryParams.f;
    //
    const [currentFace, setCurrentFace] = useState<typeHTHFace | null>(null);
    const [hthTerritory, setHTHTerritory] = useState<typeHTHTerritory | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [refreshCounter, setRefreshCounter] = useState(0);
    const dispatch = useDispatch();
    const territoryNumber = useParams<any>().territoryNumber as typeTerritoryNumber;
    const user = useGetCurrentUser();

    useEffect(() => {
        houseToHouseServices.GetTerritory(territoryNumber).then(response => {
            setIsLoading(false);
            const _hthTerritory = response.data?.hthTerritory;
            if (!response.success || !_hthTerritory) {
                dispatch(setAlertResponse({ response }))
                return;
            }
            setHTHTerritory(_hthTerritory);
            setCurrentFace(x => {
                if (x) {
                    const _currentFace = _hthTerritory.faces?.find(y => y.block === x.block && y.face === x.face) ?? null;
                    if (_currentFace) {
                        if (_currentFace.doNotCalls) {
                            _currentFace.doNotCalls.sort((d1, d2) => d1.streetNumber - d2.streetNumber);
                        }
                        if (_currentFace.observations) {
                            _currentFace.observations.reverse();
                        }
                    }
                    return _currentFace;
                } else {
                    if (!refreshCounter && blockQs && faceQs) {
                        const _currentFace = _hthTerritory.faces?.find(y => y.block === blockQs && y.face === faceQs) ?? null;
                        if (_currentFace) {
                            if (_currentFace.doNotCalls) {
                                _currentFace.doNotCalls.sort((d1, d2) => d1.streetNumber - d2.streetNumber);
                            }
                            if (_currentFace.observations) {
                                _currentFace.observations.reverse();
                            }
                        }
                        return _currentFace;
                    } else {
                        return x;
                    }
                }
            });
        });
    }, [blockQs, faceQs, refreshCounter, territoryNumber]);

    useEffect(() => {
        const handler = (e: MessageEvent) => {
            const data = JSON.parse(e.data);
            if (data.congregation !== user.congregation) {
                return;
            }
            if (!!territoryNumber && data.territoryNumber !== territoryNumber) {
                return;
            }
            setRefreshCounter(x => x + 1);
        };
        sse.addEventListener(sseEvents.hthChange, handler);
        return () => {
            sse.removeEventListener(sseEvents.hthChange, handler);
        };
    }, [user.congregation, territoryNumber]);

    if (isLoading) {
        return <Loading mt={'80px'} />;
    }

    if (!hthTerritory) {
        return <FailedToGetData />;
    }

    return (
        <>
        <H2 title={`CASA EN CASA - T${territoryNumber}`} />
        {(user.isBuildingsAdmin || user.hthAssignments.some(a => a.territoryNumber === parseInt(territoryNumber))) &&
            <>
            {hthTerritory.faces.some(f => f.buildings?.length || f.doNotCalls?.length) &&
                <HTHShare
                    hthTerritory={hthTerritory}
                    territoryNumber={territoryNumber}
                />
            }
            <HTHSection
                currentFace={currentFace}
                hthTerritory={hthTerritory}
                setCurrentFace={setCurrentFace}
                setHTHTerritory={setHTHTerritory}
                territoryNumber={territoryNumber}
            />
            </>
        }
        {hthTerritory.faces.some(f => f.buildings?.length || f.doNotCalls?.length) &&
            <HTHSearcher
                hthTerritory={hthTerritory}
            />
        }
        </>
    );
}
